import type BodyContentType from 'owa-service/lib/contract/BodyContentType';
import type {
    default as CalendarEvent,
    CalendarItemTypeTypeEx,
} from 'owa-calendar-types/lib/types/CalendarEvent';
import type { ClientFolderId, ClientItemId } from 'owa-client-ids';
import { createDisplayDate, OwaDate } from 'owa-datetime';
import type EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import type { BusyType } from 'owa-graph-schema';
import type RecurrenceType from 'owa-service/lib/contract/RecurrenceType';

/**
 * Anonymous calendar event
 */
export interface AnonymousCalendarEvent extends CalendarEvent {
    ItemId: ClientItemId;
    Charm: number;
    End: OwaDate;
    EndTimeZoneId: string;
    FreeBusyType: BusyType;
    IsAllDayEvent: boolean;
    Location: EnhancedLocation;
    ParentFolderId: ClientFolderId;
    Subject: string;
    Start: OwaDate;
    StartTimeZoneId: string;
    CalendarItemType: CalendarItemTypeTypeEx;
    Body: BodyContentType;
    Recurrence: RecurrenceType;
    IsCancelled: boolean;
    __type: 'AnonymousCalendarEvent';
}

/**
 * Converts an event to an anonymous calendar event
 */
export const convertToCalendarEvent = (event: any): AnonymousCalendarEvent => {
    const itemId: ClientItemId = {
        ...event.ItemId,
        mailboxInfo: null,
    };
    const parentFolderID: ClientFolderId = {
        ...event.ParentFolderId,
        mailboxInfo: null,
    };
    return {
        ItemId: itemId,
        End: createDisplayDate(event.End),
        Charm: event.Charm,
        FreeBusyType: event.FreeBusyType as BusyType,
        IsAllDayEvent: event.IsAllDayEvent,
        Location: event.Location,
        ParentFolderId: parentFolderID,
        Subject: event.Subject,
        Start: createDisplayDate(event.Start),
        Sensitivity: event.Sensitivity,
        StartTimeZoneId: event.StartTimeZoneId,
        CalendarItemType: event.CalendarItemType as CalendarItemTypeTypeEx,
        Body: event.Body,
        Recurrence: event.Recurrence,
        IsCancelled: event.IsCancelled,
        __type: 'AnonymousCalendarEvent',
    } as AnonymousCalendarEvent;
};
